module.exports = __webpack_public_path__ + "img/stoplights.0a5b7496.svg";